module.exports = __webpack_public_path__ + "img/icon-staircase.35c161c5.svg";